// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1v9Ql","approved":"Status_approved__1R9hD","rejected":"Status_rejected__2ZRX1","expired":"Status_expired__P6lMY","label":"Status_label__1Fwg9"};